/**
 * Standard variable names used in expression evaluation contexts.
 * These must stay in sync with VariableNames in app-runtime.
 */
export class VariableNames {
    static readonly Item = "$item";
    static readonly Event = "$event";
    static readonly Output = "$output";
    static readonly Context = "$ctx";
    static readonly Session = "$session";
    static readonly User = "$user";
    static readonly Source = "$source";
    static readonly View = "$view";
    static readonly Input = "$input";
    static readonly SearchText = "$searchText";
}
